module.exports = __webpack_public_path__ + "img/lc-logo-text.73810d67.svg";